<template>
  <div class="main col-xs-12">
    <AppMessages v-bind:message="this.message"
                 v-bind:show="this.show"
                 v-bind:type="this.messageType" />

    <h1>SPEC Update</h1>

    <form class="batchselect">
      <label class="label">Product</label>
      <selectize v-model="selectedProductId" :settings="selectizeSettings">
        <option v-for="product in products" :key="product.id" :value="product.id">
          {{ product.name }}
        </option>
      </selectize>
    </form>

    <div v-if="selectedProduct">
      <h2>Customers within the last 24 months</h2>
      <div v-if="showEmailError">
        <p style="color:red">Sorry, there is at least 1 customer who does not have a valid email address. Please rectify this before continuing.</p>
      </div>
      <table class="table">
        <thead>
          <tr>
            <th class="table__header">Customer</th>
            <th class="table__header">Customer Name</th>
            <th class="table__header">Email Addresses</th>
            <th class="table__header">Order Date</th>
            <th class="table__header">SPEC Date</th>
          </tr>
        </thead>
        <tbody v-if="specs.length">
          <tr v-bind:key="spec.id" v-for="spec in specs">
            <td class="table__col">{{ spec.customer }}</td>
            <td class="table__col" >{{ spec.name }}</td>
            <td class="table__col" v-bind:class="{'table__error': spec.hasError}">{{ spec.email }}</td>
            <td class="table__col">{{ spec.orderdate | date }}</td>
            <td class="table__col">{{ spec.specdate | date }}</td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td class="table__col" colspan="4">
              No records found
            </td>
          </tr>
        </tbody>
      </table>

      <form @submit.prevent="specUpdate" class="noborder" v-if="libraryFiles.length">
        <table class="table table--half">
          <thead>
            <tr>
              <th class="table__header"></th>
              <th class="table__header">Lib ID</th>
              <th class="table__header">File</th>
              <th class="table__header">Language</th>
              <th class="table__header">Date Added</th>
            </tr>
          </thead>
          <tbody>
            <tr v-bind:key="file.id" v-for="file in libraryFiles">
              <td class="table__col">
                <input :id="'styled-checkbox-' + file.id"
                       v-model="file.selected"
                       class="checkbox"
                       type="checkbox" />
                <label :for="'styled-checkbox-' + file.id">
                  <span class="checkbox__labelhide">Checkbox</span>
                </label>
              </td>
              <td class="table__col">{{ file.id }}</td>
              <td class="table__col">{{ file.filename }}</td>
              <td class="table__col">{{ file.language }}</td>
              <td class="table__col">{{ file.date | formatDate }}</td>
            </tr>
          </tbody>
        </table>

        <button class="button button--alt" type="submit" :disabled="!isSendEnabled">Send Update</button>
      </form>
    </div>

  </div>
</template>

<script>
  import Selectize from 'vue2-selectize';
  import axios from 'axios';
  import AppMessages from '@/components/AppMessages/AppMessages.vue';

  export default {
    name: 'specupdate',
    components: {
      Selectize,
      AppMessages,
    },
    data() {
      return {
        selectizeSettings: {
          maxOptions: 10000,
          sortField: [{ field: 'value', direction: 'asc' }, { field: '$score' }],
          allowEmptyOption: false,
          placeholder: 'Select value'
        },
        selectedProductId: null,
        selectedProduct: null,
        selectedProductName: null,
        specs: [],
        libraryFiles: [],
        products: [],
        message: '',
        messageType: '',
        show: false,
        isSendEnabled: true,
        showEmailError: false,
        hasError: false,
      };
    },
    watch: {
      selectedProductId(value) {
        const product = this.products.find(product => product.id === value) || null;
        this.selectedProduct = product;
        this.selectedProductName = product ? product.name : null;
        this.specs = [];
        this.libraryFiles = [];

      if (!value) {
          this.selectedProduct = null;
          return;
        }

        this.loadSpecData(false);
    },
    },
    mounted() {
      this.loadMasterProducts();
    },
    methods: {
      specUpdate() {
        this.$Progress.start();
        this.show = false;

        const selectedIds = this.libraryFiles.filter(x => x.selected).map(x => x.id);
        axios.post(`/products/${this.selectedProductName}/${this.selectedProductId}/send-spec`, { libraryIds: selectedIds })
          .then((r) => {

            this.specs = [];
            this.libraryFiles = [];

          this.loadSpecData(true).then((r) => {
            this.$Progress.finish();
              this.message = 'SPEC update sent';
              this.messageType = 'message message--success';
              this.show = true;
              this.$Progress.finish();
            });
          })
        .catch((e) => {
            this.message = 'SPEC update not sent';
            this.messageType = 'message message--error';
            this.show = true;
            this.$Progress.fail();
            this.$Progress.finish();
        })
      },
      loadMasterProducts() {
        this.$Progress.start();
        this.show = false;

        axios.get('/master-products')
          .then((r) => {
            this.products = r.data;
          })
        .catch((e) => {
            this.message = 'Products not loaded';
            this.messageType = 'message message--error';
            this.show = true;
            this.$Progress.fail();
          })
          .finally(() => {
            this.$Progress.finish();
          });
      },
      loadSpecData(hideProgressBarOnFinish) {
        this.$Progress.start();

      const $scope = this;

        hideProgressBarOnFinish = hideProgressBarOnFinish || false;

        this.show = false;
        this.showEmailError = false;


        return axios.all([
          axios.get(`/master-products/${this.selectedProductName}/${this.selectedProductId}/customers?type=tds`),
          axios.get(`/products/${this.selectedProductName}/${this.selectedProductId}/libraries?type=tds`)
        ])
          .then(axios.spread((c, f) => {
            const customers = c.data;

          var canSend = true;
          for (let i = 0; i < customers.length; i += 1) {
            const customer = customers[i];

            var hasEmail = customer.emails && customer.emails.length > 0;
            if (!hasEmail) {
              canSend = false;
            }

            $scope.specs.push({
                customer: customer.customer,
                name: customer.name,
                email: customer.emails ? customer.emails.join(', ') : '',
                orderdate: customer.date,
                specdate: customer.sentDate,
                hasError: !hasEmail,
              });

              if (!customer.emails || customer.emails.length == 0) {
                canSend = false;
              }
          }

            this.isSendEnabled = canSend;
            this.showEmailError = !canSend;

            const files = f.data;
          for (let i = 0; i < files.length; i += 1) {
            const file = files[i];
            $scope.libraryFiles.push({
                id: file.id,
                filename: file.filename,
                language: file.language,
                date: file.updateDateTime,
                selected: false,
              });
          }
          }))
        .catch((e) => {
            this.message = 'SDS data not loaded';
            this.messageType = 'message message--error';
            this.show = false;
            this.$Progress.fail();

            this.isSendEnabled = false;
            this.showEmailError = false;
          })
          .finally(() => {
            if (!hideProgressBarOnFinish) {
              this.$Progress.finish();
            }
          });
    },
  },
};
</script>
